import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Dialog, DialogContent } from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'

export default function ConfirmDialogPlandelivery({ open, setOpen, rows, handleAdd }) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                            ข้อมูลผลสรุปการจัดส่งเมล็ดพันธุ์
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-bordered table-hover ">
                            <thead>
                                <tr>
                                    <th scope="col " rowspan="2" class="text-center" style={{ width: '10%',position: 'inherit', }}>
                                        วัน/เดือน/ปี<br />ที่จัดส่ง</th>
                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>เลขที่</th>
                                    <th scope="col " colspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>จัดส่งโดย</th>
                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>หมายเหตุ</th>
                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>ค่าจ้างขนส่ง/กิโลกรัม</th>

                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>ค่าน้ำมัน</th>

                                    <th scope="col " colspan="3" class="text-center" style={{
                                        position: 'inherit',
                                    }}>ผู้รับจ้างขนส่ง</th>

                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>ประมาณระยะทาง (กิโลเมตร)</th>

                                </tr>
                                <tr>

                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>รถเอกชน</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>รถศูนย์</th>

                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>ชื่อบริษัท/ร้าน</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>ที่อยู่</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>เบอร์โทรศัพท์</th>

                                </tr>

                            </thead>
                            <tbody class="">
                                {rows?.map((mock) =>
                                    <tr >
                                        <td class="text-center"> {dayjs(mock?.DocumentDate).format('DD/MM/BBBB')}</td>
                                        <td class="text-center"> {mock?.DoiNo}</td>
                                        <td class="text-center">

                                            {mock.carType.private && <FontAwesomeIcon icon={faCheck} />}
                                        </td>
                                        <td class="text-center">
                                            {mock.carType.personal && <FontAwesomeIcon icon={faCheck} />}
                                        </td>
                                        <td>
                                            {mock.carType.private || mock.carType.personal ? mock?.Remark : ''}
                                        </td>

                                        {mock.carType.personal && <>

                                            <td></td>
                                            <td> {mock?.Cost}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                {mock?.Distance}</td>
                                        </>}


                                        {mock.carType.private && <>
                                            <td>{mock?.CostPerKM}</td>
                                            <td> </td>
                                            <td>
                                                {mock?.CompanyName}

                                            </td>
                                            <td>
                                                {mock?.CompanyAddress}

                                            </td>
                                            <td>
                                                {mock?.CompanyTel}

                                            </td>
                                            <td>
                                                {mock?.Distance}

                                            </td>

                                        </>}



                                    </tr >)}
                            </tbody >
                        </table >
                    </div >


                </div >
                <div class="row mt-4">

                    <div class="col-12 text-end">
                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button onClick={() => handleAdd()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>ยืนยันการทำรายการ</Button>
                    </div >
                </div >
            </DialogContent >
        </Dialog >
    )
}
